<template>
  <v-layout row>
    <v-flex
      xs12
      sm12
      md12
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card flat>
        <v-card-text>
          <div>
            <div class="select-outlet">
              {{ $t('select_outlet') }}:
            </div>
            <v-layout 
              row
              wrap
            >
              <v-flex
                d-flex
                xs12
                sm6
                md4
                lg3
                xl2
                v-for="(outlet, index) in restaurants"
                :key="index"
                class="my-3"
              >
                <outlet-selector :outlet="outlet" />
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import OutletSelector from '~/components/OutletSelector'

export default {
  name: 'outlets',
  layout: 'default',
  metaInfo () {
    return { title: 'Outlets' }
  },
  components: {
    'outlet-selector': OutletSelector
  },
  computed: {
    ...mapGetters('config', [
      'restaurants', 'config', 'theme'
    ])
  }
}
</script>

<style scoped>
.select-outlet {
  font-size: 17px;
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/pages/outlets.vue